export const INVALID_OPERATION_STATUS_URL = 'INVALID_OPERATION_STATUS_URL';

function invalidStatusUrlError() {
  const error = new Error(INVALID_OPERATION_STATUS_URL);
  error.code = INVALID_OPERATION_STATUS_URL;
  return error;
}

function encodedOperationId(operationId) {
  const normalizedOperationId = String(operationId || '').trim();
  if (!normalizedOperationId) throw invalidStatusUrlError();
  return encodeURIComponent(normalizedOperationId);
}

function requireExactApiPath(statusUrl, expectedPath) {
  if (typeof statusUrl !== 'string'
    || !statusUrl.startsWith('/api/')
    || statusUrl !== expectedPath) {
    throw invalidStatusUrlError();
  }
  return statusUrl;
}

/** Validate the backend-provided Import status path before attaching credentials. */
export function requireImportStatusUrl(statusUrl, operationId) {
  const expectedPath = `/api/data-imports/${encodedOperationId(operationId)}`;
  return requireExactApiPath(statusUrl, expectedPath);
}

/** Validate the backend-provided Recalculation status path and target identity. */
export function requireRecalculationStatusUrl(statusUrl, fiscalYear, operationId) {
  const normalizedFiscalYear = Number(fiscalYear);
  if (!Number.isInteger(normalizedFiscalYear)) throw invalidStatusUrlError();
  const expectedPath = `/api/data-input/${normalizedFiscalYear}/recalculations/`
    + encodedOperationId(operationId);
  return requireExactApiPath(statusUrl, expectedPath);
}

/** Validate the backend-provided manual EF Sync status path before polling it. */
export function requireEfSyncStatusUrl(statusUrl, operationId) {
  const expectedPath = '/api/emission-factors/sync-operations/'
    + encodedOperationId(operationId);
  return requireExactApiPath(statusUrl, expectedPath);
}
